"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaCadreSecurise = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utilitaires = require("../utils/utilitaires");

var _utilitaires2 = require("../utils/utilitaires.elements");

var _MfaContexte = require("./MfaContexte");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaCadreSecurise = /*#__PURE__*/function (_Component) {
  _inherits(MfaCadreSecurise, _Component);

  var _super = _createSuper(MfaCadreSecurise);

  function MfaCadreSecurise() {
    _classCallCheck(this, MfaCadreSecurise);

    return _super.apply(this, arguments);
  }

  _createClass(MfaCadreSecurise, [{
    key: "validerAcces",
    value: function validerAcces() {
      if (!this.aReferences()) {
        return true;
      }

      var acces = this.obtenirAcces();
      return (0, _utilitaires.estDefini)(acces) && acces.length > 0;
    }
  }, {
    key: "obtenirReferences",
    value: function obtenirReferences() {
      var _this$props = this.props,
          references = _this$props.references,
          reference = _this$props.reference;
      var referencesEffectives = [];
      referencesEffectives.push.apply(referencesEffectives, this.obtenirTableauChaine(references));
      referencesEffectives.push.apply(referencesEffectives, this.obtenirTableauChaine(reference));
      return referencesEffectives.length > 0 ? referencesEffectives : null;
    }
  }, {
    key: "obtenirTableauChaine",
    value: function obtenirTableauChaine(valeur) {
      if (!(0, _utilitaires.estDefini)(valeur)) {
        return [];
      } else if (valeur instanceof Array) {
        return valeur.filter(function (val) {
          return (0, _utilitaires.estDefini)(val);
        }).map(function (val) {
          return val.toString();
        });
      }

      return [valeur.toString()];
    }
  }, {
    key: "aReferences",
    value: function aReferences() {
      return (0, _utilitaires.estDefini)(this.obtenirReferences());
    }
  }, {
    key: "obtenirAcces",
    value: function obtenirAcces() {
      var references = this.obtenirReferences();

      if (!(0, _utilitaires.estDefini)(references)) {
        return null;
      }

      var context = this.context;

      if (!(0, _utilitaires.estDefini)(context)) {
        return null;
      }

      var listeAcces = context.listeAcces;

      if (!(0, _utilitaires.estDefini)(listeAcces)) {
        return null;
      }

      var acces = listeAcces.filter(function (acce) {
        return references.indexOf(acce.reference) !== -1;
      });
      return acces;
    }
  }, {
    key: "obtenirEnfants",
    value: function obtenirEnfants() {
      var _this = this;

      var children = this.props.children;

      if (!(0, _utilitaires.estDefini)(children)) {
        return null;
      }

      if (children instanceof Array) {
        return children.map(function (enfant) {
          return _this.formaterEnfant(enfant);
        });
      }

      return this.formaterEnfant(children);
    }
  }, {
    key: "formaterEnfant",
    value: function formaterEnfant(enfant) {
      var acces = this.obtenirAcces();
      var dictionnaireComportement = this.context.dictionnaireComportement;
      var _this$props2 = this.props,
          obtenirEnfantCible = _this$props2.obtenirEnfantCible,
          modifierEnfant = _this$props2.modifierEnfant;

      if (!(0, _utilitaires.estDefini)(acces) || acces.length === 0) {
        return null;
      } else if ((0, _utilitaires.estDefini)(acces.find(function (acces) {
        return !(0, _utilitaires.estDefini)(acces.codeComportement);
      }))) {
        return enfant;
      }

      var accesComportement = acces.find(function (acces) {
        return (0, _utilitaires.estDefini)(acces.codeComportement);
      });
      var codeComportement = accesComportement.codeComportement;

      if ((!(0, _utilitaires.estDefini)(dictionnaireComportement, codeComportement) || (0, _utilitaires.objetVide)(dictionnaireComportement[codeComportement])) && !(0, _utilitaires.estDefini)(modifierEnfant)) {
        return enfant;
      }

      var comportement = dictionnaireComportement[codeComportement];

      if (typeof enfant === 'string') {
        enfant = /*#__PURE__*/_react.default.createElement("span", null, enfant);
      }

      var enfantCible = enfant;

      if ((0, _utilitaires.estDefini)(obtenirEnfantCible)) {
        enfantCible = obtenirEnfantCible(enfant);
      }

      if ((0, _utilitaires.estDefini)(enfantCible, 'props')) {
        var enfantOriginal = enfantCible;

        if ((0, _utilitaires.estDefini)(modifierEnfant)) {
          enfantCible = modifierEnfant(enfantCible, accesComportement, comportement);
        }

        if ((0, _utilitaires.estDefini)(comportement)) {
          enfantCible = /*#__PURE__*/(0, _react.cloneElement)(enfantCible, comportement);
        }

        if (enfantOriginal === enfant) {
          return enfantCible;
        }

        return (0, _utilitaires2.remplacerComposante)(enfant, enfantOriginal, enfantCible);
      }

      return enfant;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.validerAcces()) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.obtenirEnfants());
    }
  }]);

  return MfaCadreSecurise;
}(_react.Component);

exports.MfaCadreSecurise = MfaCadreSecurise;

_defineProperty(MfaCadreSecurise, "contextType", _MfaContexte.MfaContexte);